import { cartOptions, modalProductOptions, productOptions, productSetOptions, toggleOptions } from './style'

/* eslint-env browser */

const scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js'

function ShopifyBuyInit() {
  const client = window.ShopifyBuy.buildClient({
    domain: 'fishfriender.myshopify.com',
    storefrontAccessToken: '6c068ce352984b42fc038e53b9519dff',
  })

  Array.from(document.getElementsByClassName('shopify-embed')).forEach(node => {
    window.ShopifyBuy.UI.onReady(client).then(function(ui) {
      ui.createComponent('collection', {
        id: 61434331197,
        node,
        moneyFormat: '%E2%82%AC%7B%7Bamount%7D%7D',
        options: {
          product: productOptions,
          cart: cartOptions,
          modalProduct: modalProductOptions,
          toggle: toggleOptions,
          productSet: productSetOptions,
        },
      })
    })
  })
}

function loadScript(handler) {
  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = scriptURL
  ;(document.getElementsByTagName('body')[0] || document.getElementsByTagName('head')[0]).appendChild(script)
  script.onload = handler
}

export default (opts = {}) => {
  if (window.ShopifyBuy) {
    if (window.ShopifyBuy.UI) {
      ShopifyBuyInit(opts)
    } else {
      loadScript(() => {
        ShopifyBuyInit(opts)
      })
    }
  } else {
    loadScript(() => {
      ShopifyBuyInit(opts)
    })
  }
}
